export default __webpack_public_path__ + "static/media/right-arrow.fc6c35f8.svg";